import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Check Circle".
 *
 * @property {string} [tooltip] - The tooltip to display on hover.
 */
@Component({
    selector: 'app-icon-check-circle',
    templateUrl: './icon-check-circle.component.html',
    styleUrls: ['./icon-check-circle.component.scss'],
    standalone: false
})
export class IconCheckCircleComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
